module.exports = __webpack_public_path__ + "img/Q1-image.eac58f9b.png";